"use client";

import React from "react";
import {
  Clock,
  Route,
  Link as LinkIcon,
  MessageCircle,
  ShoppingCart,
  PackageSearch,
} from "lucide-react";

type Feature = {
  title: string;
  desc: string;
  Icon: React.ComponentType<{ className?: string }>;
};

export default function FeaturesSectionLikeImage() {
  const features: Feature[] = [
    {
      title: "Automated FAQ responses",
      desc: "Answer customer questions instantly on WhatsApp.",
      Icon: Clock,
    },
    {
      title: "Smooth sales flow with AI Sales Assistant",
      desc: "Guide customers from inquiry to purchase effortlessly.",
      Icon: Route,
    },
    {
      title: "Shopify, Website and CRM integrations",
      desc: "Connect your chatbot to your business tools and sell more.",
      Icon: LinkIcon,
    },
    // If you want exactly 3 cards (like screenshot), keep only the first 3.
    // Add more cards later if needed:
    // { title: "Instant support", desc: "24/7 answers and human handoff when needed.", Icon: MessageCircle },
    // { title: "Sell on WhatsApp", desc: "Recommend products and boost conversions.", Icon: ShoppingCart },
    // { title: "Order updates", desc: "Reduce “Where is my order?” with tracking links.", Icon: PackageSearch },
  ];

  return (
    <section id="features" className="bg-white py-16">
      <div className="mx-auto max-w-6xl px-4">
        {/* Outer blue container */}
        <div className="rounded-3xl border border-sky-200 bg-sky-50/70 p-6 shadow-sm sm:p-10">
          {/* Header */}
          <div className="text-center">
            <h2 className="text-3xl font-semibold tracking-tight text-slate-900">
              Features
            </h2>
            <p className="mt-2 text-sm text-slate-600">
              Smart tools for efficient and personalized communication
            </p>
          </div>

          {/* Cards */}
          <div className="mt-10 grid gap-6 lg:grid-cols-3">
            {features.slice(0, 3).map((f) => (
              <div
                key={f.title}
                className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-black/5"
              >
                <div className="flex items-center gap-4">
                  <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-slate-50 ring-1 ring-slate-200">
                    <f.Icon className="h-5 w-5 text-slate-800" />
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-slate-900 text-left">
                      {f.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-slate-600 text-left">
                      {f.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-12 flex justify-center">
            <a
              href="#contact"
              className="inline-flex items-center justify-center rounded-xl border-2 border-slate-900 bg-emerald-400 px-6 py-3 text-sm font-semibold text-slate-900 shadow-sm hover:bg-emerald-300"
            >
              Talk to us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
